/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
/* eslint-disable no-unused-vars */
import get from "lodash/get";
import PropTypes, { func } from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import canUseDom from "../../../utils/can-use-dom";
import camelCase from "lodash/camelCase";

const PBThemeSetting = props => {
  const supportedPages = {
    "home-page": "home",
    "section-page": "section",
    "collection-page": "section",
    "tag-page": "tag",
    "author-page": "author",
    "pagebuilder-section-preview-page": "section",
    "pagebuilder-collection-preview-page": "section",
    "pagebuilder-story-preview-page": "story",
    "authors-page": "authors",
    "": ""
  };

  const subPageType = camelCase(props.subPageType);

  const storyPageColor = get(props.pbConfig, ["story", `${subPageType}-story`, "pageSettings", "bgColor"], "#fff");

  const supportedStoryPages = ({ subPageType }) => {
    switch (subPageType) {
      case "photo":
      case "liveBlog":
      case "text":
        return storyPageColor;
      default:
        return "";
    }
  };

  const getPageBgColor = get(props.pbConfig, [supportedPages[props.pageType], "pageSetting", "bgColor"], "#fff");
  const pageBgColor = props.pageType === "story-page" ? supportedStoryPages({ subPageType }) : getPageBgColor;

  useEffect(() => {
    if (canUseDom) {
      document.getElementsByTagName("body")[0].style.backgroundColor = pageBgColor;
    }
    return function cleanup() {
      if (canUseDom) {
        document.getElementsByTagName("body")[0].style.backgroundColor = "";
      }
    };
  });
  return null;
};

PBThemeSetting.propTypes = {
  pageTypes: PropTypes.string
};

const mapStatetoProps = state => {
  return {
    pbConfig: get(state, ["qt", "config", "pagebuilder-config"], {}),
    pageType: get(state, ["qt", "pageType"], ""),
    subPageType: get(state, ["qt", "data", "subPageType"], "")
  };
};

export const PBThemeSettings = connect(mapStatetoProps)(PBThemeSetting);
